import {useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';
import {Subscription} from '@yeobill/chat/lib/types';

import {RootState} from '../../store';

const useMessageSendNotification = () => {
  const {session, currentOpponent} = useSelector((state: RootState) => state.chat);
  const currentChatUserId = session?.user_id ?? '';
  const {userId} = useSelector((state: RootState) => state.user);
  const subscription = useRef<Subscription | null>(null);

  useEffect(() => {
    if (!currentChatUserId) {
      subscription.current?.unsubscribe();
      subscription.current = null;
    }

    return () => {
      subscription.current?.unsubscribe();
    };
  }, [currentOpponent, currentChatUserId, userId]);
};

export default useMessageSendNotification;
